import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import { Settings } from "@hermes/app-core";
import { GridFilter, GridFilterGroup } from "@hermes/states/grid-filters-state";

@Component({
    selector: "h-grid-checkbox",
    templateUrl: "./grid-checkbox.component.html",
    styleUrls: ["./grid-checkbox.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridCheckboxComponent {
    @Input()
    public filterId: string;

    @Input()
    public filter: GridFilter;

    @Input()
    public filterGroup: GridFilterGroup;

    constructor(private settings: Settings) {}

    /**
     * @param filter GridFilter that contains the id of the image
     * @returns Return the img url
     */
    public getAsset(filter: GridFilter): string {
        const base = this.settings.assetsUrlProduct;
        const color = `MAIN_COLOR_${filter.value.toUpperCase()}`;

        return `${base}${color}?wid=50&hei=50`;
    }
}
